import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageSevilla = props => {
  return <CityLandingPage cityKey="Sevilla" cityConfig={cityContent.sevilla} {...props} />;
};

export default LandingPageSevilla;
